export const getAlturaAtual = () => {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

export default {
  data: () => ({
    alturaDaJanela: getAlturaAtual()
  }),
  created() {
    window.addEventListener("resize", this.atualizaAlturaDaJanela);
  },
  destroyed() {
    window.addEventListener("resize", this.atualizaAlturaDaJanela);
  },
  methods: {
    atualizaAlturaDaJanela() {
      this.alturaDaJanela = getAlturaAtual();
    },
  }
}
